import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const abcClassificationMetricSchema = createEnum([
  "revenue",
  "velocity",
  "margin",
  "units_on_hand",
]);

export const abcClassificationSchema = z.discriminatedUnion("mode", [
  z.object({ mode: z.literal("smart") }),
  z.object({
    mode: z.literal("threshold"),
    metric: abcClassificationMetricSchema,
    a_pct: z.int().min(1).max(98),
    b_pct: z.int().min(1).max(98),
    c_pct: z.int().min(1).max(98),
  }),
]);

export const abcRuleDataSchema = z.object({
  a_days: z.int().min(1),
  b_days: z.int().min(1),
  c_days: z.int().min(1),
  classification: abcClassificationSchema,
});

export const cycleCountRuleDataSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("abc"), data: abcRuleDataSchema }),
]);

export type CycleCountRuleData = z.infer<typeof cycleCountRuleDataSchema>;
export type AbcRuleData = z.infer<typeof abcRuleDataSchema>;
